import React from 'react'
const SvgSort = ({ title, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...{ ...props, rotated: undefined }}
  >
    <title>{title}</title>
    <path
      fillRule="currentColor"
      d="M12.4781 9.20224C12.7385 9.46259 12.7385 9.8847 12.4781 10.145L8.47116 14.1519C8.21081 14.4122 7.7887 14.4122 7.52836 14.1519L3.52144 10.145C3.26109 9.88468 3.26108 9.46257 3.52143 9.20222C3.78178 8.94187 4.20389 8.94187 4.46424 9.20222L7.99976 12.7377L11.5353 9.20223C11.7957 8.94188 12.2178 8.94189 12.4781 9.20224Z"
      fill="currentColor"
    />
    <path
      fillRule="currentColor"
      d="M3.52194 7.13134C3.26158 6.871 3.26156 6.44889 3.5219 6.18853L7.52863 2.18149C7.65365 2.05645 7.82322 1.98621 8.00004 1.98621C8.17685 1.9862 8.34643 2.05644 8.47145 2.18147L12.4784 6.1884C12.7387 6.44875 12.7387 6.87086 12.4784 7.13121C12.218 7.39156 11.7959 7.39156 11.5356 7.13121L8.00007 3.5957L4.46475 7.1313C4.20441 7.39166 3.7823 7.39168 3.52194 7.13134Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgSort
